var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let CkanResourceFormatTraits = (_dec = primitiveTrait({
  name: "ID",
  description: "The ID of this distribution format.",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Format Regular Expression",
  description: "A regular expression that is matched against the distribution's format. This must be defined for this format to be used",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "URL Regular Expression",
  description: "A regular expression that is matched against the url, this will only be used if `formatRegex` matches.",
  type: "string"
}), _dec4 = primitiveTrait({
  name: "Maximum file size (MB)",
  description: "The maximum allowed file size for this format (in megabytes).",
  type: "number",
  isNullable: true
}), _dec5 = primitiveTrait({
  type: "boolean",
  name: "Only use if sole resource",
  description: "This resource will only match if no other resource types match for a given dataset. Like a \"last-resort\" resource. This will be ignored if `useSingleResource` is used"
}), _dec6 = primitiveTrait({
  type: "boolean",
  name: "Remove duplicate resources",
  description: "Remove resources if they have the same `name`. If duplicates are found, then the newest resource will be used (according to created property). This is applied per format"
}), _dec7 = anyTrait({
  name: "Definition",
  description: "The catalog member definition to use when the URL and Format regular expressions match. The `URL` property will also be set."
}), _class = class CkanResourceFormatTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "id", _descriptor, this);
    _initializerDefineProperty(this, "formatRegex", _descriptor2, this);
    _initializerDefineProperty(this, "urlRegex", _descriptor3, this);
    _initializerDefineProperty(this, "maxFileSize", _descriptor4, this);
    _initializerDefineProperty(this, "onlyUseIfSoleResource", _descriptor5, this);
    _initializerDefineProperty(this, "removeDuplicates", _descriptor6, this);
    _initializerDefineProperty(this, "definition", _descriptor7, this);
  }
  static isRemoval(format) {
    return format.definition === null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatRegex", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "urlRegex", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "maxFileSize", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "onlyUseIfSoleResource", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "removeDuplicates", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "definition", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CkanResourceFormatTraits as default };